<template>
  <v-main style="margin-top: 65px">
    <v-container
      fluid
      :style="{
        'background-image': 'url(' + require('@/assets/RegisterPage.png') + ')',
        'background-position': 'bottom right',
        'padding-bottom': '50px',
        'background-size': 'contain',
        height: '100%',
      }"
    >
      <v-row>
        <v-col cols="12" class="d-flex pt-7 justify-center">
          <v-card
            style="
              background: #ffffff;
              box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
              border-radius: 20px;
            "
            width="460"
          >
            <v-container>
              <v-col class="justify-center">
                <h1
                  style="
                    text-align: center;
                    font-weight: 800;
                    font-size: 28px;
                    line-height: 36px;
                    letter-spacing: 0.04em;
                    font-family: Mont;
                    font-style: normal;
                  "
                >
                  Update Your Password
                </h1>
                <p
                  style="
                    text-align: center;
                    font-size: 14px;
                    color: #a9a9a9;
                    margin-top: 8px;
                  "
                >
                  Your password must be updated before you can continue.
                  Please create a new password with at least 16 characters.
                </p>
                <v-form ref="form" style="margin-top: 24px" lazy-validation>
                  <p class="titletext">Current Password</p>
                  <v-text-field
                    :append-icon="showOld ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showOld ? 'text' : 'password'"
                    @click:append="showOld = !showOld"
                    maxlength="255"
                    v-model="oldPassword"
                    flat
                    outlined
                    placeholder="Enter current password"
                    style="margin-bottom: 4px"
                    :error-messages="
                      $v.oldPassword.$errors.length
                        ? $v.oldPassword.$errors[0].$message
                        : ''
                    "
                  ></v-text-field>

                  <p class="titletext">New Password</p>
                  <v-text-field
                    :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showNew ? 'text' : 'password'"
                    @click:append="showNew = !showNew"
                    maxlength="255"
                    v-model="newPassword"
                    flat
                    outlined
                    placeholder="Enter new password (min. 16 characters)"
                    style="margin-bottom: 4px"
                    :error-messages="
                      $v.newPassword.$errors.length
                        ? $v.newPassword.$errors[0].$message
                        : ''
                    "
                  ></v-text-field>

                  <p class="titletext">Confirm New Password</p>
                  <v-text-field
                    :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showConfirm ? 'text' : 'password'"
                    @click:append="showConfirm = !showConfirm"
                    maxlength="255"
                    v-model="confirmPassword"
                    flat
                    outlined
                    placeholder="Confirm new password"
                    style="margin-bottom: 22px"
                    :error-messages="
                      $v.confirmPassword.$errors.length
                        ? $v.confirmPassword.$errors[0].$message
                        : ''
                    "
                  ></v-text-field>

                  <v-btn
                    id="submit"
                    block
                    height="50"
                    :disabled="loading"
                    depressed
                    color="secondary"
                    class="mr-4 mt-2 text-capitalize font-weight-bold"
                    @click="submit"
                  >
                    {{ loading ? "Updating..." : "Update Password" }}
                  </v-btn>
                  <br />
                </v-form>
              </v-col>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
import { ref } from "@vue/composition-api";
import useVuelidate from "@vuelidate/core";
import { required, minLength } from "@vuelidate/validators";
import { useNamespacedActions } from "vuex-composition-helpers";
import { HOMEPAGE } from "../homepage/namespace";
var validator = require("validator");

export default {
  setup(props, context) {
    const oldPassword = ref("");
    const newPassword = ref("");
    const confirmPassword = ref("");
    const loading = ref(false);
    const oldPasswordError = ref("");

    const $v = useVuelidate(
      {
        oldPassword: {
          required,
          oldPasswordMatch: {
            $message: "Current password is incorrect",
            $validator: () => !oldPasswordError.value,
          },
        },
        newPassword: {
          required,
          minLength: minLength(16),
          isStrongPassword: {
            $message: "Must include uppercase and lowercase letters",
            $validator: (val) => {
              return (
                !!val &&
                validator.isStrongPassword(val, {
                  minLength: 1,
                  minLowercase: 1,
                  minUppercase: 1,
                  minNumbers: 0,
                  minSymbols: 0,
                })
              );
            },
          },
          isStrongPassword1: {
            $message: "Must include a number",
            $validator: (val) => {
              return (
                !!val &&
                validator.isStrongPassword(val, {
                  minLength: 1,
                  minLowercase: 0,
                  minUppercase: 0,
                  minNumbers: 1,
                  minSymbols: 0,
                })
              );
            },
          },
          isSymbol: {
            $message: "Must include a symbol",
            $validator: (val) => {
              return (
                !!val && !!val.match(/.*[-@#!$%^&*()_+|~=`{}[\]:";'<>?,./ ].*$/)
              );
            },
          },
          notSameAsOld: {
            $message: "New password cannot be the same as current password",
            $validator: (val) => val !== oldPassword.value,
          },
        },
        confirmPassword: {
          required,
          conditional: {
            $message: "Passwords do not match",
            $validator: (val) => val === newPassword.value,
          },
        },
      },
      { oldPassword, newPassword, confirmPassword }
    );

    const { changepassword } = useNamespacedActions("PROFILE", ["changepassword"]);

    const submit = async () => {
      oldPasswordError.value = "";
      $v.value.$touch();
      if ($v.value.$errors.length) return;

      loading.value = true;
      try {
        await changepassword({
          old_password: oldPassword.value,
          new_password: newPassword.value,
          confirm_password: confirmPassword.value,
        });

        localStorage.removeItem("force_change_password");

        const role = localStorage.getItem("role");
        if (role === "Superadmin") {
          window.location.href = "/manage-organization";
        } else if (role === "GodMode") {
          window.location.href = "/manage-superadmin";
        } else {
          window.location.href = "/project";
        }
      } catch (e) {
        const data = e?.response?.data?.data;
        if (data === "old_password not match") {
          oldPasswordError.value = data;
          $v.value.$reset();
          $v.value.oldPassword.$touch();
        } else if (data) {
          context.root.$store.dispatch("HOMEPAGE/showErrorToast", data);
        }
      } finally {
        loading.value = false;
      }
    };

    return {
      oldPassword,
      newPassword,
      confirmPassword,
      loading,
      $v,
      submit,
      showOld: ref(false),
      showNew: ref(false),
      showConfirm: ref(false),
    };
  },
};
</script>
<style lang="scss" scoped>
.titletext {
  font-weight: 700;
  font-size: 12px;
  margin-bottom: 4px;
}
</style>
